import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const NewDatabase = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M22.5 9H2.5V19C2.5 19.5523 2.94772 20 3.5 20L21.5 20C22.0523 20 22.5 19.5523 22.5 19V9Z"
          fill="#2D425B"
          fillOpacity="0.05"
        />
        <path d="M22.5 4H2.5V9L22.5 9V4Z" fill="#2D425B" fillOpacity="0.1" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.49995 4.74995C2.50003 3.92157 3.17156 3.25 4 3.25H14.75H21.2503C22.0788 3.25 22.7504 3.92159 22.7503 4.75003L22.75 19.25C22.75 20.0784 22.0784 20.75 21.25 20.75H14.75H3.9993C3.17147 20.75 2.50004 20.0793 2.49941 19.2514C2.49684 15.8845 2.49787 12.5175 2.4989 9.15087C2.49935 7.68382 2.4998 6.21683 2.49995 4.74995ZM7.74998 4.25H14.25V8.5H7.74998V4.25ZM6.74998 4.25H4C3.72387 4.25 3.49998 4.47386 3.49995 4.75005C3.49982 6.0001 3.49947 7.25007 3.4991 8.5H6.74998V4.25ZM6.74998 9.5H3.49879C3.49829 11.1667 3.49781 12.8334 3.4978 14.5H6.74998V9.5ZM6.74998 15.5H3.49785C3.498 16.7502 3.49846 18.0004 3.49941 19.2506C3.49962 19.5264 3.72332 19.75 3.9993 19.75H6.74998V15.5ZM7.74998 19.75V15.5L14.25 15.5V19.75H7.74998ZM7.74998 14.5V9.5H14.25L14.25 14.5L7.74998 14.5ZM15.25 4.25V8.5H21.7502L21.7503 4.75001C21.7503 4.47386 21.5265 4.25 21.2503 4.25H15.25ZM15.25 9.5L15.25 14.5H21.4999C21.5911 14.5 21.6765 14.5244 21.7501 14.567L21.7502 9.5H15.25ZM15.25 15.5V19.75H21.25C21.5261 19.75 21.75 19.5261 21.75 19.25L21.7501 15.433C21.6765 15.4756 21.5911 15.5 21.4999 15.5H15.25Z"
          fill={color}
        />
        <path
          d="M23.5 18C23.5 20.7614 21.2614 23 18.5 23C15.7385 23 13.5 20.7614 13.5 18C13.5 15.2386 15.7385 13 18.5 13C21.2614 13 23.5 15.2386 23.5 18Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 15.4286C19 15.1524 18.7762 14.9286 18.5 14.9286C18.2239 14.9286 18 15.1524 18 15.4286V17.5H15.9286C15.6524 17.5 15.4286 17.7239 15.4286 18C15.4286 18.2761 15.6524 18.5 15.9286 18.5H18V20.5714C18 20.8476 18.2239 21.0714 18.5 21.0714C18.7762 21.0714 19 20.8476 19 20.5714V18.5H21.0714C21.3476 18.5 21.5714 18.2761 21.5714 18C21.5714 17.7239 21.3476 17.5 21.0714 17.5H19V15.4286Z"
          fill="white"
        />
      </svg>
    )
  },
)

export default NewDatabase
